export default "__VITE_ASSET__B0YgoW3v__"